import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Grid, ThemeProvider, makeStyles } from "@material-ui/core";
import AdInfoBox from "../../components/Ad/AdInfoBox";
import { shop } from "../../utils/newApi";
import theme from "../Login/LoginSreen.breakpoints";
import ErrorSnackBar from "../../components/Snackbar/ErrorSnackBar";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./AdInfoScreen.styles";

import { ERROR_MESSAGES } from "../../constants/dictionary";

const useStyles = makeStyles(styles);

const AdInfoScreen = () => {
  const classes = useStyles();
  const { id } = useParams();
  const [ads, setAdd] = useState([]);
  const [error, setError] = useState(false);
  const [errorText, setErrorText] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);

  const handleError = (text) => {
    setError(true);
    setErrorText(text);
  };

  useEffect(() => {
    shop.ads
      .one(id)
      .then((res) => {
        setAdd(res.data);
        setIsLoaded(true);
      })
      .catch((err) => {
        handleError(ERROR_MESSAGES.COULD_NOT_CONNECT_TO_SERVER);
      });
  }, []);

  return (
    <ThemeProvider theme={theme}>
      {isLoaded ? (
        <Grid
          container
          justifyContent="center"
          direction="row"
          alignItems="center"
        >
          <Grid item xs={12}>
            <AdInfoBox info={ads} handleError={handleError} />
          </Grid>
        </Grid>
      ) : (
        <div className={classes.container}>
          <CircularProgress color="secondary" className={classes.loader} />
        </div>
      )}
      <ErrorSnackBar
        open={error}
        text={errorText}
        close={() => setError(false)}
      />
    </ThemeProvider>
  );
};

export default AdInfoScreen;
